import { h } from '@stencil/core';
import { ETabType, scrollToComponent, tryParse, decodeFromURI } from '@pes-ui/utils';
import { pasteScripts } from '../../../globals/utils/helpers';
export class SDLContent {
  constructor() {
    this.getTabType = (sdlComponentId) => {
      switch (sdlComponentId) {
        case 'ecostruxure':
          return ETabType.ECOSTRUXURE;
        default:
          return null;
      }
    };
    this.sdlHtmlContent = undefined;
    this.sdlComponentId = undefined;
    this._sdlHtmlContent = undefined;
    this._sdlComponentId = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleTabClicked(event) {
    if (this.el && event.detail.type === this.getTabType(this.sdlComponentId)) {
      scrollToComponent(this.el);
    }
  }
  componentWillLoad() {
    var _a, _b;
    this.sdlHtmlContent = (_a = tryParse(this._sdlHtmlContent)) !== null && _a !== void 0 ? _a : this.sdlHtmlContent;
    this.sdlComponentId = (_b = tryParse(this._sdlComponentId)) !== null && _b !== void 0 ? _b : this.sdlComponentId;
  }
  componentDidRender() {
    if (this.sdlHtmlContent) {
      pasteScripts(this.el, '.sdl-content');
    }
  }
  render() {
    this.el.innerHTML = '';
    if (this.sdlHtmlContent) {
      try {
        return (h("div", { class: {
            'sdl-content': true,
            'sdl-content--ecostruxure': this.sdlComponentId === 'ecostruxure',
          }, innerHTML: decodeFromURI(this.sdlHtmlContent) }));
      }
      catch (error) {
        console.log(error);
      }
    }
    return null;
  }
  static get is() { return "pes-sdl-content"; }
  static get originalStyleUrls() {
    return {
      "$": ["sdl-content.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["sdl-content.css"]
    };
  }
  static get properties() {
    return {
      "sdlHtmlContent": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sdl-html-content",
        "reflect": false
      },
      "sdlComponentId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sdl-component-id",
        "reflect": false
      },
      "_sdlHtmlContent": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sdl-html-content",
        "reflect": false
      },
      "_sdlComponentId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sdl-component-id",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
